// remove description field on thematique list page
if (document.body.classList.contains('taxonomy-thematique') && ! document.body.classList.contains('edit-tags-php')) {
  var thematiqueDescriptionTextArea = document.getElementById('description')
  var parent = thematiqueDescriptionTextArea.closest('.form-field')
  parent.parentNode.removeChild(parent)
}

// remove description field on thematique single page
if (document.body.classList.contains('edit-tags-php')) {
  var parent = document.getElementsByClassName('term-description-wrap')
  if (parent.length) {
    for (var i = 0; i < parent.length; i ++) {
      parent[i].parentNode.removeChild(parent[i])
    }
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/admin.js